var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8476 4.53125L17.4697 5.15385L10.8741 11.7494L10.252 11.1273L16.8476 4.53125Z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5993 8.79844H16.7193V5.27844H13.1993V4.39844H17.5993V8.79844ZM15.3993 16.7184H6.5993C5.8513 16.7184 5.2793 16.1464 5.2793 15.3984V6.59844C5.2793 5.85044 5.8513 5.27844 6.5993 5.27844H11.4393V6.15844H6.5993C6.3353 6.15844 6.1593 6.33444 6.1593 6.59844V15.3984C6.1593 15.6624 6.3353 15.8384 6.5993 15.8384H15.3993C15.6633 15.8384 15.8393 15.6624 15.8393 15.3984V10.5584H16.7193V15.3984C16.7193 16.1464 16.1473 16.7184 15.3993 16.7184Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/externalLink.4c70d339d610482816bea1a34a8d93a5.svg";
export { ForwardRef as ReactComponent };